import { ChatConversationHistoryArray, ChatCurrentMessagesArray, ChatbotRole } from "../models/chatbotModels";

export interface ChatbotState {
  currentState: string;
  selectedRole: string;
  selectedRoleLabel: string;
  selectedBrand: string;
  isStreaming: boolean;
  isCreating: boolean;
  streamingQuestion?: string;
  streamingResponse?: string;
  conversationHistory?: ChatConversationHistoryArray,
  selectedConversationId: string;
  selectedConversationMssgs?: ChatCurrentMessagesArray;
  errors: string[],
}
export interface ChatBotStates {
  [key: string]: {
    on: {
      [key: string]: string;
    };
  };
}

export type ChatbotAction =
  { type: "TRANSITION"; payload: string } |
  { type: "UPDATE_IS_STREAMING"; payload: boolean } |
  { type: "UPDATE_IS_CREATING"; payload: boolean } |
  { type: "UPDATE_SELECTED_ROLE"; payload: ChatbotRole } |
  { type: "UPDATE_SELECTED_BRAND"; payload: string } |
  { type: "UPDATE_STREAMING_QUESTION"; payload: string } |
  { type: "UPDATE_STREAMING_RESPONSE"; payload: string } |
  { type: "UPDATE_CONVERSATION_HISTORY"; payload: ChatConversationHistoryArray } |
  { type: "UPDATE_SELECTED_CONVERSATION_MSSGS"; payload: ChatCurrentMessagesArray } |
  { type: "ERROR"; payload: string } |
  { type: "CLEAR_SELECTED_CONVERSATION" } |
  { type: "RESET" };

const chatBotMachineStates: {
  initial: string;
  states: ChatBotStates
} = {
  initial: "Connecting State",
  states: {
    "Initial State": {
      on: {
        CONNECT_TO_WS: "Connecting State",
      },
    },
    "Connecting State": {
      on: {
        CONNECT_SUCCESS: "Connected State",
        CONNECT_FAILURE: "Error Connecting State",
      },
    },
    "Connected State": {
      on: {
        CONNECT_FAILURE: "Error Connecting State",
        SESSION_TIMEOUT: "Session Timeout State",
      },
    },
    "Session Timeout State": {
      on: {
        // timeout also closes connection, stay at timeout state until connect success
        CONNECT_FAILURE: "Session Timeout State",
        CONNECT_SUCCESS: "Connected State",
      },
    },
    "Error Connecting State": {
      on: {
        CONNECT_SUCCESS: "Connected State",
        CONNECT_FAILURE: "Error Connecting State",
      },
    },
  },
};

export const initialChatBotState: {
  currentState: string,
  isStreaming: boolean,
  isCreating: boolean,
  selectedRole: string,
  selectedRoleLabel: string,
  selectedBrand: string,
  streamingQuestion: string,
  streamingResponse: string,
  conversationHistory: []
  selectedConversationId: string,
  selectedConversationMssgs: [],
  errors: [],
} = {
  currentState: chatBotMachineStates.initial,
  isStreaming: false,
  isCreating: false,
  selectedRole: "",
  selectedRoleLabel: "",
  selectedBrand: "",
  streamingResponse: "",
  streamingQuestion: "",
  conversationHistory: [],
  selectedConversationId: "",
  selectedConversationMssgs: [],
  errors: [],
};

const chatbotStateReducer = (state: ChatbotState, action: ChatbotAction): ChatbotState => {
  if (action.type === "TRANSITION") {
    const nextState = chatBotMachineStates.states[state.currentState]?.on[action.payload] || state.currentState;
    return {
      ...state,
      currentState: nextState
    };
  } else if (action.type === "UPDATE_IS_STREAMING") {
    return {
      ...state,
      isStreaming: action.payload
    };
  } else if (action.type === "UPDATE_IS_CREATING") {
    return {
      ...state,
      isCreating: action.payload
    };
  }
  else if (action.type === "CLEAR_SELECTED_CONVERSATION") {
    return {
      ...state,
      selectedConversationId: "",
      selectedConversationMssgs: [],
    };
  } else if (action.type === "UPDATE_STREAMING_QUESTION") {
    return {
      ...state,
      streamingQuestion: action.payload
    };
  } else if (action.type === "UPDATE_STREAMING_RESPONSE") {
    return {
      ...state,
      streamingResponse: action.payload
    };
  } else if (action.type === "UPDATE_CONVERSATION_HISTORY") {
    if (state.isCreating) {
      return {
        ...state,
        isCreating: false,
        selectedConversationId: action.payload[0].conversation_id,
        conversationHistory: action.payload
      };
    } else {
      return {
        ...state,
        conversationHistory: action.payload
      };
    }
  } else if (action.type === "UPDATE_SELECTED_CONVERSATION_MSSGS") {
    return {
      ...state,
      selectedConversationId: action.payload[0]?.conversation_id ? action.payload[0]?.conversation_id : "",
      selectedConversationMssgs: action.payload,
      streamingQuestion: "",
      streamingResponse: ""
    };
  }
  else if (action.type === "UPDATE_SELECTED_ROLE") {
    return {
      ...state,
      selectedRole: action.payload.wingmanRole,
      selectedRoleLabel: action.payload.displayRole,
      selectedConversationId: "",
      conversationHistory: [],
      selectedConversationMssgs: [],
    };
  } else if (action.type === "UPDATE_SELECTED_BRAND") {
    return {
      ...state,
      selectedBrand: action.payload,
      selectedConversationId: "",
      conversationHistory: [],
      selectedConversationMssgs: [],
    };
  } else if (action.type === "ERROR") {
    return {
      ...state,
      errors: [...state.errors, action.payload]
    };
  } else if (action.type === "RESET") {
    return {
      ...state,
      currentState: chatBotMachineStates.initial
    };
  }
  else {
    return state;
  }
};

export default chatbotStateReducer;



